import { Component } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { UtilisateurService } from 'src/services/utilisateur.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-deplacer-utilisateurs',
    templateUrl: './deplacer-utilisateurs.component.html',
    styleUrls: ['./deplacer-utilisateurs.component.scss'],
    imports: [
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    TranslateModule
]
})
export class DeplacerUtilisateursComponent {
  emailInput: string = '';
  novoEntiteId: number | null = null;
  isLoading: boolean = false;

  constructor(
    private utilisateurService: UtilisateurService,
    private snackBar: MatSnackBar
  ) { }

  get emails(): string[] {
    return this.emailInput
      .split('\n')
      .map(e => e.trim())
      .filter(e => e && this.isValidEmail(e));
  }

  isValidEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  deplacer(): void {
    if (this.emails.length === 0) {
      this.snackBar.open('Veuillez ajouter au moins un email', 'Fermer', { duration: 3000 });
      return;
    }

    if (!this.novoEntiteId) {
      this.snackBar.open('Veuillez entrer un ID d\'entité destination', 'Fermer', { duration: 3000 });
      return;
    }

    this.isLoading = true;

    this.utilisateurService.deplacerUtilisateurs(this.emails, this.novoEntiteId).subscribe({
      next: () => {
        this.snackBar.open('Utilisateurs déplacés avec succès', 'Fermer', { duration: 5000 });
        this.emailInput = '';
        this.novoEntiteId = null;
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Erreur lors du déplacement:', error);
        this.snackBar.open(
          error.error?.message || 'Erreur lors du déplacement des utilisateurs',
          'Fermer',
          { duration: 5000 }
        );
        this.isLoading = false;
      }
    });
  }
}
